'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _apiHelper = require('api/api-helper');

var _messageActions = require('actions/messageActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(sendReminderMessage);

function sendReminderMessage() {
    var _ref, payload, customerId, checkinUrl, recipientEmail, authToken, bookingId, _ref2, postedMessage, error;

    return _regenerator2.default.wrap(function sendReminderMessage$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!true) {
                        _context.next = 26;
                        break;
                    }

                    _context.next = 3;
                    return (0, _effects.take)(_messageActions.MESSAGE_POST_REQUESTED);

                case 3:
                    _ref = _context.sent;
                    payload = _ref.payload;
                    customerId = payload.customerId, checkinUrl = payload.checkinUrl, recipientEmail = payload.recipientEmail;
                    _context.next = 8;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 8:
                    authToken = _context.sent;
                    _context.next = 11;
                    return (0, _effects.select)(function (state) {
                        return state.booking.id;
                    });

                case 11:
                    bookingId = _context.sent;
                    _context.next = 14;
                    return (0, _effects.call)(_apiHelper.postMessage, {
                        customer: { id: customerId },
                        template: { code: 'GOODTOGO_REMINDER' },
                        single_resources: [{
                            name: 'bookings',
                            id: bookingId
                        }],
                        context: {
                            goodtogo_link: checkinUrl,
                            receivers: [{
                                type: 'TO',
                                value: [recipientEmail]
                            }]
                        }
                    }, authToken);

                case 14:
                    _ref2 = _context.sent;
                    postedMessage = _ref2.postedMessage;
                    error = _ref2.error;

                    if (!error) {
                        _context.next = 22;
                        break;
                    }

                    _context.next = 20;
                    return (0, _effects.put)((0, _messageActions.messagePostFailed)({ _error: 'MESSAGE_POST_FAILED' }));

                case 20:
                    _context.next = 24;
                    break;

                case 22:
                    _context.next = 24;
                    return (0, _effects.put)((0, _messageActions.messagePostSucceeded)(postedMessage));

                case 24:
                    _context.next = 0;
                    break;

                case 26:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = sendReminderMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/sendReminderMessage.js
// module id = 1421
// module chunks = 0